import React from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import ReactApexChart from "react-apexcharts";

const FinansGrafik = () => {
  // Statik veya API'den gelecek örnek grafik verisi (LojGo işlem hacmine göre uyarlandı)
  const series = [{ name: "Sistem Cirosu (TL)", data: [14200, 18500, 20100, 15600, 23700, 30500, 28000, 35800, 39200, 48200, 57200, 63200] }];
  
  const options = {
    chart: { type: "area", height: 240, toolbar: { show: false } },
    colors: ["#556ee6"],
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 2 },
    fill: { 
      type: "gradient", 
      gradient: { shadeIntensity: 1, opacityFrom: 0.45, opacityTo: 0.05, stops: [20, 100, 100, 100] } 
    },
    xaxis: { categories: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"] },
    yaxis: { labels: { formatter: (value) => value.toLocaleString('tr-TR') + " TL" } }
  };

  return (
    <Card className="shadow-sm border-0 h-100">
      <CardBody>
        <CardTitle className="mb-3">Aylık İşlem Hacmi (Ciro)</CardTitle>
        <ReactApexChart series={series} options={options} type="area" height={240} className="apex-charts" />
      </CardBody>
    </Card>
  );
};

export default FinansGrafik;